import React, { Fragment, useCallback } from "react";
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  Filter,
  TextInput,
  TopToolbar,
  CreateButton,
} from "react-admin";
import { Route, useHistory } from "react-router-dom";
import { Drawer } from "@material-ui/core";

import ReferenceTypeCreate from "./ReferenceTypeCreate";
import ReferenceTypeEdit from "./ReferenceTypeEdit";

import { Roles } from "../../utils/enums";
import { FormGeneral } from "../../styles/FormGeneral";

const Filters = (props) => (
  <Filter {...props} variant="outlined">
    <TextInput label="ra.action.search" source="name" alwaysOn />
  </Filter>
);

const Actions = ({ permissions, basePath }) => (
  <TopToolbar>
    {permissions === Roles.admin && <CreateButton basePath={basePath} />}
  </TopToolbar>
);

const ReferenceTypeList = ({ permissions, ...props }) => {
  const classes = FormGeneral();
  const history = useHistory();

  const handleClose = useCallback(() => {
    history.push("/reference-types");
  }, [history]);

  return (
    <Fragment>
      <List
        filters={<Filters />}
        actions={<Actions permissions={permissions} />}
        bulkActionButtons={permissions === Roles.admin ? undefined : false}
        {...props}
      >
        <Datagrid>
          <TextField source="id" />
          <TextField source="name" />
          <TextField source="description" />
          {permissions === Roles.admin && <EditButton />}
        </Datagrid>
      </List>
      {permissions === Roles.admin && (
        <Route path="/reference-types/create">
          {({ match }) => (
            <Drawer open={!!match} anchor="right" onClose={handleClose}>
              <ReferenceTypeCreate
                className={classes.drawerContent}
                onCancel={handleClose}
                {...props}
              />
            </Drawer>
          )}
        </Route>
      )}
      {permissions === Roles.admin && (
        <Route path="/reference-types/:id">
          {({ match }) => {
            const isMatch = !!(
              match &&
              match.params &&
              match.params.id !== "create"
            );

            return (
              <Drawer open={isMatch} anchor="right" onClose={handleClose}>
                {isMatch ? (
                  <ReferenceTypeEdit
                    className={classes.drawerContent}
                    id={match.params.id}
                    onCancel={handleClose}
                    {...props}
                  />
                ) : (
                  <div className={classes.drawerContent} />
                )}
              </Drawer>
            );
          }}
        </Route>
      )}
    </Fragment>
  );
};

export default ReferenceTypeList;
